/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ReusableMethods/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Method from './Method/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function ReusableMethods({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods",
  amount
  
}) {
let reusableMethodsPaymentsTokensValueData = fromData.useDataValue({ viewPath,
context: 'reusable_methods',
path: 'payments_tokens',
})
  return (<React.Fragment
>
<div
  data-testid="ReusableMethods.List"
  data-view-path={viewPath}
 className="views-block"
>
{Array.isArray(reusableMethodsPaymentsTokensValueData) && reusableMethodsPaymentsTokensValueData.map((item, index, list) => 
<ListItem
        key={item?.id ?? item?._id ?? index}
        context="reusable_method"
        item={item}
        index={index}
        list={list}
        hasItemKey={false}
        parentViewPath={viewPath}
        viewPath={`${viewPath}/Method(${item?.id ?? item?._id ?? index})`}
      >
<Method
 index={index} indexReverse={list.length - index} isFirst={index === 0} isLast={index === list.length - 1}
 item={item}
 viewPath={`${viewPath}/Method(${item?.id ?? item?._id ?? index})`}
 amount={amount}
/>
</ListItem>
)}
</div>
{children}
</React.Fragment>)
}

  function ListItem(props) {
    let valueItem = React.useMemo(() => ({
      index: props.index,
      indexReverse: props.list.length - props.index,
      isFirst: props.index === 0,
      isLast: props.index === props.list.length - 1,
    }), [props.index, props.list])
    
    
    
    return (
      <fromData.DataProvider
      context={props.context}
      value={props.item}
      
      
      viewPath={props.viewPath}
    >
      <fromData.DataProvider
        context={`${props.context}_item`}
        value={valueItem}
        viewPath={props.viewPath}
      >
        {props.children}
      </fromData.DataProvider>
    </fromData.DataProvider>
    )
  }